import { render, staticRenderFns } from "./SuggestedInterpretation.vue?vue&type=template&id=8dbd156a"
import script from "./SuggestedInterpretation.vue?vue&type=script&lang=js"
export * from "./SuggestedInterpretation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports